import './NavBar.scss';
import NavItem from './NavItem';
import { useState, useEffect, useRef, useCallback } from 'react';

const OBSERVER_OPTIONS = {
    root: null,
    rootMargin: "-30% 0% -30% 0%",
    threshold: 0
};


export default function NavBar() {
    const sectionTitles = ["About", "Experience", "Projects"];
    
    let navRef = useRef<HTMLDivElement>(null);
    let observer: IntersectionObserver | null = null;
    let [visibleSections, setVisibleSections] = useState(Array<string>);
    let [visibleSectionID, setVisibleSectionID] = useState('');
    
    const handleScroll = useCallback(() => {
        const isSticky = window.scrollY > 0;

        if (isSticky) {
            navRef.current?.classList.add('-sticky');
        } else {
            navRef.current?.classList.remove('-sticky');
        }
    }, []);
    
    const handleNavObs = (entries: Array<IntersectionObserverEntry>, observer: IntersectionObserver) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                setVisibleSections(oldSections => [entry.target.id, ...oldSections]);
            } else {
                setVisibleSections(oldSections => oldSections.filter(s => s !== entry.target.id));
            }
        });
    };

    useEffect(() => {
        setVisibleSectionID(visibleSections[0]);
    }, [visibleSections]);


    useEffect(() => {
        observer = new IntersectionObserver(handleNavObs, OBSERVER_OPTIONS);

        sectionTitles.map(title => {
            const el = document.querySelector('.section#' + title.toLowerCase());
            el && observer?.observe(el);
        });

        window.addEventListener('scroll', handleScroll);

        return () => {
            observer?.disconnect();
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return <div className='navbar' ref={navRef}>
        <div className='nav-items-wrapper'>
            {sectionTitles.map((title) => 
                <NavItem key={title} title={title} highlightedTitle={visibleSectionID}/>
            )}
        </div>
    </div>;
};